import { render, staticRenderFns } from "./MaidDetail.vue?vue&type=template&id=8bb785d2&scoped=true"
import script from "./MaidDetail.vue?vue&type=script&lang=js"
export * from "./MaidDetail.vue?vue&type=script&lang=js"
import style0 from "./MaidDetail.vue?vue&type=style&index=0&id=8bb785d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb785d2",
  null
  
)

export default component.exports